import React, { Fragment, useCallback, useState } from 'react';
import { Personal } from '../../../../Constant';
import ListNewContact from './ListNewContact';
import ContactDetailsClass from './ContactDetail';
import UpdateUser from './UpdateUser';
import { Row, Col, Card, CardBody, TabContent, TabPane } from 'reactstrap';
import HeaderCard from '../../../Common/Component/HeaderCard';

const PersonalTab = ({ supervisors, eng }) => {

    let init_user=supervisors!=undefined && supervisors!=null&&supervisors.length > 0 ? supervisors[0] :'';
    
    const [selectedUser, setSelectedUser] = useState('');
    const dynamictab = useState('0');
    const [editing, setEditing] = useState(false);
    const [editdata, setEditData] = useState({});
    const [editUrl, setEditUrl] = useState({});
    const [imgUpdate, setImgUpdate] = useState(false);

    const userCallback = useCallback((user) => {
        setSelectedUser(user);
        setImgUpdate(false);
    }, []);

    const userEditCallback = useCallback((edit, usersData, editurl, imgUpdate) => {
        setEditData(usersData);
        setSelectedUser(usersData);
        setEditing(edit);
        setEditUrl(editurl);
        setImgUpdate(imgUpdate);
    }, []);
//alert(JSON.stringify(supervisors[0]));

let my_title, my_officers='';

if(eng=='ps_approver') {
    my_title=" Accounting Officers (PS)";
    my_officers="Officers";
}
else if(eng=='general_approver') {
    my_title=" Secretariat Officers";
    my_officers="Officers";
}
else if(eng=='committee_approver') {
    my_title=" Evaluation Board Members";
    my_officers="Members";
}
else if(eng=='psp_approver') {
    my_title=" Permnent Secretary to the President (PSP)";
    my_officers="Officer";
}

    return (
        <Fragment>
           {supervisors!=undefined && supervisors!=null? ( <Card>
                <HeaderCard mainClasses="d-flex" title={my_title} span1={`${supervisors.length} `+my_officers} />
                <CardBody className="p-0">
                    <Row className="list-persons" id="addcon">
                        <ListNewContact eng={eng} supervisors={supervisors} userCallback={userCallback} />
                        <Col xl="8" md="7" className='xl-50'>
                            {editing ?
                                <UpdateUser imgUpdate={imgUpdate} editdata={editdata} editurl={editUrl} userEditCallback={userEditCallback} />
                                :
                                <TabContent activeTab={dynamictab}>
                                    <TabPane tabId={dynamictab}>
                                        <ContactDetailsClass eng={eng} imgUpdate={imgUpdate} selectedUser={selectedUser !='' ? selectedUser : supervisors[0]} editurl={editUrl} userEditCallback={userEditCallback} />
                                    </TabPane>
                                </TabContent>
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>):null}
        </Fragment>
    );
};

export default PersonalTab;